import { __assign, __rest } from "tslib";
import React from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../internal/base-component';
import InternalAlert from '../alert/internal';
import InternalBox from '../box/internal';
import styles from './styles.css.js';
export default function InternalForm(_a) {
    var children = _a.children, header = _a.header, errorText = _a.errorText, actions = _a.actions, __internalRootRef = _a.__internalRootRef, props = __rest(_a, ["children", "header", "errorText", "actions", "__internalRootRef"]);
    var baseProps = getBaseProps(props);
    return (React.createElement("div", __assign({}, baseProps, { className: clsx(styles.root, baseProps.className), ref: __internalRootRef }),
        header && React.createElement("div", { className: styles.header }, header),
        children && React.createElement("div", { className: styles.content }, children),
        React.createElement("div", { "aria-live": "assertive" }, errorText && (React.createElement(InternalBox, { margin: { top: 'l' } },
            React.createElement(InternalAlert, { type: "error" },
                React.createElement("div", { className: styles.error }, errorText))))),
        actions && React.createElement("div", { className: styles.actions }, actions)));
}
//# sourceMappingURL=internal.js.map